import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider as MaterialThemeProvider } from "@material-tailwind/react";
import { ThemeProvider } from "./context/ThemeContext";
import AppRouter from "./AppRouter";
import { AuthProvider } from "./context/AuthContext";
import { BusinessProfileProvider } from "./context/BusinessProfileContext";
import { PageProvider } from "./context/PageContext";
import { MPSBusinessProfileProvider } from "./context/MPSBusinessProfileContext";
import { OnboardingProvider } from "./context/OnboardingContext";
import ScrollToTop from "./components/ScrollToTop";
import "./index.css";
import "./i18n";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />
      <ThemeProvider>
        <MaterialThemeProvider>
          <AuthProvider>
            <PageProvider>
              <BusinessProfileProvider>
                <MPSBusinessProfileProvider>
                  <OnboardingProvider>
                    <AppRouter />
                  </OnboardingProvider>
                </MPSBusinessProfileProvider>
              </BusinessProfileProvider>
            </PageProvider>
          </AuthProvider>
        </MaterialThemeProvider>
      </ThemeProvider>
    </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
